import {
  Box,
  Button,
  IconButton,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  FONT_FAMILY,
  NAVBAR_FOOTER_TEXT_COLOR,
  TEXT_COLOR,
} from "../../theme";

export const styles = {
  button: {
    textTransform: "none",
    color: TEXT_COLOR,
    width: "100%",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontSize: 16,
    fontWeight: "bold",
    borderRadius: "var(--radius-md, 8px)",
  } as const,
  avatarAndNameContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  } as const,
  pageNameContainer: {
    display: "flex",
    gap: "10px",
    padding: "8px",
    borderRadius: "5px",
    ":hover": {
      cursor: "pointer",
    },
    alignItems: "center"
  } as const,
  supportBox: {
    display: "flex",
    gap: "10px",
    margin: "20px 4px",
    ":hover": {
      cursor: "pointer",
    },
  } as const,
  storageDetailsContainer: {
    display: "flex",
    gap: "10px",
    border: "1px solid #26292B",
    padding: "15px",
    borderRadius: "15px",
    marginBottom: "25px",
    ":hover": {
      cursor: "pointer",
    },
  } as const,
  cloudIconContainer: {
    height: "45px",
    width: "45px",
    borderRadius: "50%",
    border: "1px solid #26292B",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: APP_COLOR,
  } as const,
  socialMediaLinksContainer: {
    display: "flex",
    justifyContent: "space-between"
  } as const,
  iconButton: {
    padding: 0,
    margin: 0
  } as const,
  socialButtonContainer: {
    border: "1px solid #26292B",
    padding: "10px",
    borderRadius: "10px",
  } as const,

  moreVerticalIconMenu: {
    border: "1px solid #26292B",
    "& .MuiPaper-root": {
      backgroundColor: APP_BACKGROUND_COLOR,
      color: TEXT_COLOR,
      border: `1px solid ${BORDER_COLOR}`,
      borderRadius: "10px",
      boxShadow: "0px 18px 50px rgba(0, 0, 0, 0.55)",
    },
    "& .MuiList-root": {
      margin: 0,
      padding: "4px",
    },
    "& .MuiMenuItem-root": {
      color: TEXT_COLOR,
      fontFamily: FONT_FAMILY,
      fontSize: "14px",
      borderRadius: "8px",
      margin: "2px 4px",
      "&:hover": {
        backgroundColor: "#1F242F",
      },
    },
  } as const,
  logoContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  } as const,
  folderMenuIcon: {
    cursor: "pointer",
    "& ul": {
      backgroundColor: APP_BACKGROUND_COLOR,
      cursor: "pointer",
    },
    "&:hover": {
      background: BORDER_COLOR,
    },
  } as const,
  editFolderNameModal: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  trialModeContainer: {
    borderRadius: "10px",
    padding: "2px",
    backgroundColor: "#f5ca7e",
    textAlign: "center",
    marginBottom: "10px",
  } as const,
};

export const trackGridViewStyles = {
  mainContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    gap: "30px",
    paddingTop: "20px",
  } as const,
  cardContainer: {
    borderRadius: "15px",
    border: "1px solid #1F242F",
    height: "400px",
  } as const,
  photoContainer: {
    display: "flex",
    justifyContent: "center",
    height: "60%",
    position: "relative",
  } as const,
  collaboratorsContainer: {
    position: "absolute",
    bottom: 0,
    right: 0,
    zIndex: 1,
    marginRight: "10px",
    marginBottom: "15px",
  } as const,
  photo: {
    width: "95%",
    margin: "10px",
    borderRadius: "10px",
  } as const,
  trackDetailsContainer: {
    width: "95%",
    margin: "10px",
    height: "30%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  } as const,
  trackTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px",
  } as const,
  checkBoxContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
    marginLeft: "10px",
    marginTop: "10px",
  } as const,
  pauseIcon: {
    width: "20px",
    height: "20px",
    filter: "invert(100%)",
  } as const,
};

export const collaboratorsStyles = {
  navLink: {
    textDecoration: "none",
    color: "black",
    margin: "auto",
    marginLeft: 2,
    marginRight: 2,
    marginBottom: "10px",
  } as const,
  stylesProfilePic: {
    width: "40px",
    height: "40px",
    marginLeft: "2px",
    color: "white",
    backgroundColor: "#393A3B",
  } as const,
  avatarGroup: {
    "& .MuiAvatar-root": {
      fontSize: 18,
      fontFamily: FONT_FAMILY,
      color: "#cfcfcf",
      backgroundColor: "#393A3B",
    },
  } as const,
  userProfileNavLink: {
    textDecoration: "none",
    color: "black",
    margin: "auto",
  } as const,
  collaboratorsContainer: {
    minWidth: "250px",
    display: "flex",
    flexWrap: "wrap",
    maxWidth: "250px",
  } as const,
  customizedTooltipBox: {
    fontSize: 12,
    color: "white",
    margin: "4px",
    textAlign: "center",
  } as const,
  customizedTooltip: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    maxHeight: 150,
    maxWidth: 265,
    overflowY: "auto",
    padding: 0.1,
    gap: 2,
  } as const,
  collaboratorBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "4px",
  } as const,
  userNameBox: {
    fontSize: 12,
    color: "white",
    marginTop: "4px",
    textAlign: "center",
  } as const,
};

export const filterMenuStyles = {
  filterMenuContainer: {
    padding: "20px 20px 30px 20px",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  filterMenuBox: {
    padding: "15px",
    backgroundColor: APP_BACKGROUND_COLOR
  } as const,
  menuPaperProps: {
    border: "1px solid #26292B",
  } as const,
  menu: {
    border: "1px solid #26292B",
    "& ul": {
      margin: 0,
      padding: 0,
    },
  } as const,
  genreContainer: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: "20px",
  } as const,
  selectAndTextField: {
    width: "320px"
  } as const,
  genreSelect: {
    width: "320px",
    fontFamily: FONT_FAMILY,
    color: TEXT_COLOR,
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
    },
    "&.Mui-focused fieldset": {
      borderColor: APP_COLOR,
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  } as const,
  collaboratorsContainer: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: "20px",
  } as const,
  bpmContainer: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: "20px",
  } as const,
  filterRightSideBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  } as const,
  artistContainer: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: "20px",
  } as const,
  artistSelect: {
    width: "320px",
    fontFamily: FONT_FAMILY,
    color: TEXT_COLOR,
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  } as const,
  privacyContainer: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: "20px",
  } as const,
  privacySelect: {
    width: "320px",
    fontFamily: FONT_FAMILY,
    color: TEXT_COLOR,
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  } as const,
  buttonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "30px",
    gap: "20px",
  } as const,
  genreMenuProps: {
    maxHeight: 300,
    "& ul": {
      padding: 0,
    },
  } as const,
};

export const sortMenuStyles = {
  paperProps: {
    border: "1px solid #26292B",
  } as const,
  menu: {
    border: "1px solid #26292B",
    "& ul": {
      margin: 0,
      padding: 0,
    },
  } as const,
  button: {
    borderRadius: "var(--radius-md, 8px)",
    height: "55px",
    color: TEXT_COLOR,
    fontWeight: "bold",
    border: `1px solid ${BORDER_COLOR}`,
    background:
      "var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #161B26)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    textTransform: "none",
    fontSize: "14px",
    paddingRight: "20px",
    "&:hover": {
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  } as const,
};

export const trackMenuStyles = {
  paperProps: {
    border: "1px solid #26292B",
  } as const,
  menu: {
    border: "1px solid #26292B",
    "& ul": {
      margin: 0,
      padding: 0,
    },
    "& .MuiMenuItem-root": {
      borderRadius: "8px",
    },
    "& .MuiMenuItem-root:hover": {
      backgroundColor: "var(--surface-hi)",
      color: "var(--white)",
    },
  } as const,
};

export const AddMusicSectionStyles = {
  button: {
    borderRadius: "var(--radius-md, 8px)",
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    "&:disabled": {
      backgroundColor: 'grey',
    },
    backgroundColor: APP_COLOR,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    paddingX: 2,
    fontSize: "14px",
    height: "37px",
    padding: "10px",
  } as const,
  buttonBox: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "20px",
  } as const,
};

export const DrawerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexShrink: 0,
  position: "sticky",
  top: "var(--guest-banner-height, 0px)",
  height: "calc(100vh - var(--guest-banner-height, 0px))",
  alignSelf: "flex-start",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const TracksPageMainContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "35px",
  paddingTop: "10px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "20px",
  },
}));

export const ControllersContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "15px",
  },
}));

export const CustomGridContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3,1fr)",
  gap: "30px",
  paddingTop: "20px",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "repeat(3,1fr)",
  },
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(1,1fr)",
  },
}));

export const CustomFilterMenuContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "15px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));

export const TrackNameAndCheckBoxContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "5px",
  gap: "5px",
  width: "340px",
  alignItems: "center",
  [theme.breakpoints.down("lg")]: {
    width: "310px",
    gap: 0,
  },
  "@media (max-width: 1400px)": {
    width: "250px",
  },
}));

export const mobileScreenBottomNavigationStyles = {
  mainContainer: {
    position: "fixed",
    bottom: 0,
    zIndex: 1000,
    display: "grid",
    gridTemplateColumns: "repeat(4,1fr)",
    background: "var(--Colors-Background-bg-primary, #0C111D)",
    backgroundBlendMode: "hard-light",
    boxShadow: "0px -0.33px 0px 0px rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(25px)",
    width: "100%",
    padding: "10px 0px 10px 0px",
  } as const,
  tabContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "10px",
  } as const,
  imageContainer: {
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
  } as const,
  typography: {
    fontSize: "12px",
  } as const,
};

export const audioPlayerStyles = {
  imageTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  } as const,
  playerContainer: {
    margin: "0px 25px 0px 25px",
    justifyContent: "space-between",
  } as const,
  outerPlayerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "80%",
  } as const,
  waveformContainer: {
    width: "100%",
    height: "30px",
    position: "relative",
    overflow: "hidden",
  } as const
};

export const ArtWorkAndCollaboratorsContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const OuterPlayerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "80%",
  [theme.breakpoints.down("md")]: {},
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: 0,
  padding: 0,
  [theme.breakpoints.down("md")]: {
    marginRight: -2,
  },
}));

export const AudioPlayerTime = styled(Typography)(({ theme }) => ({
  marginLeft: "30px",
  minWidth: "80px",
  [theme.breakpoints.down("md")]: {
    marginLeft: "5px",
  },
}));

export const AudioPlayerMainContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(31, 36, 47, 0.85)", // Glass effect base color
  backdropFilter: "blur(16px)", // Blur for glass effect
  height: "72px", // Slightly slimmer
  width: "calc(100% - 40px)", // 20px gap on each side
  maxWidth: "1200px", // Cap width on ultra-wide screens
  position: "sticky", // Sticky allows it to adjust when sidebar collapses
  bottom: "24px", // Floating above the bottom
  margin: "0 auto", // Centers it within the dynamic width container
  zIndex: 999,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "36px", // Pill shape
  border: `1px solid rgba(255, 255, 255, 0.1)`, // Subtle glow/border
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)", // Floating shadow
  paddingLeft: "24px",
  paddingRight: "24px",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  [theme.breakpoints.down("sm")]: {
    bottom: "86px", // Above mobile bottom nav
    width: "calc(100% - 32px)", // 16px padding on each side
    borderRadius: "24px", // Slightly less rounded on mobile
    paddingLeft: "16px",
    paddingRight: "16px",
    height: "auto",
    minHeight: "64px",
  },
}));

export const MainContainer = styled(Box)(({ theme }) => ({
  backgroundColor: APP_BACKGROUND_COLOR,
  height: "80px",
  width: "75.5%",
  position: "fixed",
  bottom: 0,
  zIndex: 9999,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "10px",
  border: `1px solid ${BORDER_COLOR}`,
  paddingLeft: "20px",
  paddingRight: "20px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

export const TrackNameAndStatusContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.down("md")]: {
    maxWidth: "150px",
  },
}));

export const CollAndVersionContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "25%",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    width: "auto",
  },
}));

export const CustomIconButtonForPlayPause = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "50px",
  width: "50px",
}));

export const TrackLeftSideContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "80%",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
}));

export const DcContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "collapsed",
})<{ collapsed?: boolean }>(({ theme, collapsed }) => ({
  border: "1px solid #26292B",
  boxSizing: "border-box",
  height: "100%",
  overflowY: "auto",
  width: collapsed ? "72px" : "300px",
  padding: collapsed ? "12px" : "25px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  transition: "width 200ms ease, padding 200ms ease",
  [theme.breakpoints.down("xl")]: {
    width: collapsed ? "72px" : "290px",
  },
  [theme.breakpoints.down("md")]: {
    width: collapsed ? "72px" : "220px",
    padding: "12px",
  },
}));

export const PlayerContainer = styled(Box)(({ theme }) => ({
  margin: "0px 25px 0px 25px",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    margin: 0,
    marginRight: "5px",
  },
}));

export const CloseButtonContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const MasterIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
  },
}));

export const FilterAndSortButton = styled(Button)(({ theme }) => ({
  borderRadius: "var(--radius-md, 8px)",
  height: "55px",
  color: TEXT_COLOR,
  fontWeight: "bold",
  border: `1px solid ${BORDER_COLOR}`,
  background:
    "var(--Component-colors-Components-Buttons-Secondary-button-secondary-bg, #161B26)",
  boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  textTransform: "none",
  fontSize: "14px",
  paddingRight: "20px",
  "&:hover": {
    boxShadow:
      "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
  },
  [theme.breakpoints.down("xl")]: {
    height: "45px",
  },
  [theme.breakpoints.down("md")]: {
    height: "40px",
  },
}));

export const CustomTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    color: NAVBAR_FOOTER_TEXT_COLOR,
    height: "22px"
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
      boxShadow:
        "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)",
    },
  },
  position: "relative",
  marginRight: "10px",
  width: "320px",
  borderRadius: "var(--radius-md, 8px)",
  [theme.breakpoints.down("xl")]: {
    "& input": {
      height: "10px",
    },
  },
  [theme.breakpoints.down("md")]: {
    "& input": {
      height: "auto",
    },
  },
}));